// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time
import { getTimezoneOffset } from "date-fns-tz";

/**
 * we are first converting the existing date picked from the Date picker(start of day in User timezone)
 * to the facility timezone by adding the offset values.
 */
export function convertDateToFacilityTimeZone(date: Date, facilityTmz: string) {
  return new Date(
    date.getTime() +
      (getTimezoneOffset(Intl.DateTimeFormat().resolvedOptions().timeZone) -
        getTimezoneOffset(facilityTmz))
  );
}
